<template>
  <div class="container-card">
    <header>
      <div class="container-card__head">
        <slot name="tipbar"></slot>

        <div class="container-card__head-content">
          <slot name="logo"></slot>

          <div class="container-card__title-content">
            <h1 class="container-card__title">
              <span v-html="title"></span>
              <tooltip v-if="tooltip" :title="tooltip" :html="html" />
            </h1>

            <h2 class="container-card__subtitle">
              <slot name="subtitle"></slot>
            </h2>

            <div class="container-card__alerts-insights">
              <select-monitoring-alert
                :title="title"
                :alerts="alerts"
                v-if="alerts.length > 0"
              />

              <be-max-modal :beMax="beMax" mode="line" />
            </div>
          </div>
          <a
            v-if="linkUrl"
            :href="linkUrl"
            target="_blank"
            class="container-card__link"
          >
            {{ linkText }}
            <i :class="linkIcon"></i>
          </a>
        </div>

        <div class="container-card__selects">
          <nave-select
            v-if="checkOptions"
            :options="selectOptions"
            @optionSelected="optionSelected"
          />
          <date-range
            v-if="checkDate"
            :time="datePeriod"
            @dateUpdated="updateDate($event)"
          />
        </div>
      </div>
    </header>

    <slot />
  </div>
</template>

<script lang="ts">
import { defineComponent, computed } from "vue";

export default defineComponent({
  name: "ContainerCard",

  props: {
    linkText: {
      type: String,
      default: "Documentação técnica",
    },
    linkIcon: { type: String, default: "icon-nav-open-in-new" },
    linkUrl: { type: String, default: "" },
    title: { type: String, default: "" },
    tooltip: { type: String, default: "" },
    html: { type: Boolean, default: false },
    alerts: { type: Array, default: () => [] },
    datePeriod: { type: Array, default: () => [] },
    selectOptions: {
      type: Object,
      default: () => {
        return {};
      },
    },
    beMax: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },

  setup(props, context) {
    const checkDate = computed(() => {
      return props.datePeriod.length > 0;
    });

    const checkOptions = computed(() => {
      return Object.keys(props.selectOptions).length > 0;
    });

    const updateDate = ($event: any) => {
      if ($event.length) {
        context.emit("dateUpdated", $event);
      }
    };

    const optionSelected = ($event: any) => {
      context.emit("optionSelected", $event);
    };

    return {
      checkDate,
      checkOptions,
      updateDate,
      optionSelected,
    };
  },
});
</script>

<style lang="scss">
.container-card {
  background: var(--insights-color-2);
  box-sizing: border-box;
  border-radius: 4px;
  padding: toRem(46px);
  margin-bottom: toRem(38px);
  box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.1);
  position: relative;

  &__head {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    align-items: baseline;
    &-content {
      display: flex;
      align-items: center;
      gap: 10px;
      i {
        font-size: 2.5rem;
        color: var(--insights-color-16);
      }
    }
  }

  &__title {
    font-family: "text-regular";
    color: var(--insights-color-1);
    font-size: toRem(30px);

    img {
      width: 40px;
      height: 40px;
      margin-left: 10px;
    }

    span i {
      font-size: toRem(16px);
      margin-left: 5px;
      color: var(--insights-color-16);
    }
  }

  &__subtitle {
    font-family: "text-medium";
    color: var(--insights-color-16);
    font-size: toRem(16px);
    display: flex;
    margin-bottom: 0;

    i {
      margin: 0 5px 0 10px;
      font-size: toRem(16px);
      margin-left: 5px;
    }
  }

  &__link {
    font-family: "text-medium";
    font-size: toRem(13px);
    line-height: normal;
    font-weight: 400;
    color: var(--insights-color-23);
    text-decoration: none;
    position: absolute;
    right: 46px;
    display: flex;
    align-items: center;
    gap: 4px;
    i {
      font-size: toRem(16px);
      color: var(--insights-color-23);
    }
  }

  &__right {
    display: flex;
    gap: 20px;
  }

  &__selects {
    display: flex;
    gap: toRem(30px);
  }

  &__alerts-insights {
    display: flex;
    gap: toRem(30px);
    align-items: center;
  }
}
</style>
